import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Box } from '../Box/index.js';

const sizes = {
  xsmall: '0.75em',
  small: '1em',
  medium: '1.5em',
  large: '2em'
};
/**
 * keyframes + css method from styled-components offer proper code-splitting
 * https://www.styled-components.com/docs/basics#animations
 */
const rotate = keyframes(["to{transform:rotate(360deg);}"]);
const StyledLoading = styled(Box).withConfig({
  displayName: "Loading__StyledLoading",
  componentId: "sc-1ogw8ec-0"
})(["", ""], _ref => {
  let {
    speed
  } = _ref;
  return css(["animation:", " ", " linear infinite;"], rotate, speed);
});
/**
 * The Loading component provides a visual cue that an action is either
 * processing, awaiting a course of change or a result.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/loading#usage)
 * - [Props](https://blockparty.endpoint.com/components/loading#props)
 * <br />
 *
 */
const Loading = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    color = 'blue500',
    dataTestId = 'loading',
    emptyColor = 'transparent',
    size = 'small',
    speed = '0.6s',
    thickness = '2px',
    ...props
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(StyledLoading, _extends({
    ref: forwardedRef,
    "aria-busy": "true",
    "aria-label": "Loading",
    borderRadius: "radiusFull",
    borderRight: `${thickness} solid ${emptyColor}`,
    borderTop: `${thickness} solid`,
    borderTopColor: "currentColor",
    color: color,
    "data-test-id": dataTestId,
    display: "inline-block",
    position: "relative",
    role: "status",
    size: sizes[size],
    speed: speed
  }, props));
});

export { Loading };
